var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"cast"},[_vm._v("\n  출연 :\n  "),_vm._l((_vm.actorList),function(actor,index){return _c('span',{key:`actors_${index}`},[_vm._v("\n    "+_vm._s(actor.value)+_vm._s(_vm.actorList.length - 1 !== index ? ', ' : '')+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }